(() => {
  async function fetchCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!r.ok) throw new Error('cart_fetch_failed');
    return r.json();
  }

  function findCartIcon() {
    return (
      document.getElementById('cart-icon-bubble') ||
      document.querySelector('a.header__icon--cart') ||
      document.querySelector('a[href="/cart"]')
    );
  }

  function ensureBubble(icon) {
    if (!icon) return null;
    let bubble = icon.querySelector('.cart-count-bubble');
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = `
        <span aria-hidden="true">0</span>
        <span class="visually-hidden">Cart</span>
      `;
      icon.appendChild(bubble);
    }
    return bubble;
  }

  async function updateBadge() {
    try {
      const cart = await fetchCart();
      const count = Number(cart?.item_count || 0);

      document.querySelectorAll('#cart-icon-bubble, a.header__icon--cart, a[href="/cart"]').forEach((icon) => {
        const bubble = ensureBubble(icon);
        if (!bubble) return;

        const aria = bubble.querySelector('span[aria-hidden="true"]');
        if (aria) aria.textContent = String(count);

        // Dawn hides the bubble when empty
        bubble.style.display = count > 0 ? '' : 'none';
      });
    } catch (e) {}
  }

  // Hook fetch so any cart write triggers a badge refresh
  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await _fetch.apply(this, args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
        setTimeout(updateBadge, 50);
      }
    } catch (e) {}
    return res;
  };

  // Also refresh after ATC clicks/submits (covers theme JS differences)
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form) return;
    if (form.matches('form[action^="/cart/add"]') || form.matches('form[data-type="add-to-cart-form"]')) {
      setTimeout(updateBadge, 200);
    }
  }, true);

  document.addEventListener('click', (e) => {
    const btn = e.target?.closest?.('button[name="add"], input[name="add"]');
    if (btn) setTimeout(updateBadge, 200);
  }, true);

  document.addEventListener('DOMContentLoaded', updateBadge);
})();
